__turbopack_context__.v({
  "badge": "ui-module__Hi2WXW__badge",
  "badgeAccent": "ui-module__Hi2WXW__badgeAccent",
  "block": "ui-module__Hi2WXW__block",
  "button": "ui-module__Hi2WXW__button",
  "cell": "ui-module__Hi2WXW__cell",
  "cellDescription": "ui-module__Hi2WXW__cellDescription",
  "cellLabel": "ui-module__Hi2WXW__cellLabel",
  "cellLeading": "ui-module__Hi2WXW__cellLeading",
  "cellTrailing": "ui-module__Hi2WXW__cellTrailing",
  "danger": "ui-module__Hi2WXW__danger",
  "full": "ui-module__Hi2WXW__full",
  "ghost": "ui-module__Hi2WXW__ghost",
  "header": "ui-module__Hi2WXW__header",
  "headerSide": "ui-module__Hi2WXW__headerSide",
  "headerTitle": "ui-module__Hi2WXW__headerTitle",
  "iconButton": "ui-module__Hi2WXW__iconButton",
  "primary": "ui-module__Hi2WXW__primary",
  "screen": "ui-module__Hi2WXW__screen",
  "secondary": "ui-module__Hi2WXW__secondary",
  "segment": "ui-module__Hi2WXW__segment",
  "segmentActive": "ui-module__Hi2WXW__segmentActive",
  "segments": "ui-module__Hi2WXW__segments",
  "sheet": "ui-module__Hi2WXW__sheet",
  "sheetHandle": "ui-module__Hi2WXW__sheetHandle",
  "sheetOverlay": "ui-module__Hi2WXW__sheetOverlay",
  "tab": "ui-module__Hi2WXW__tab",
  "tabActive": "ui-module__Hi2WXW__tabActive",
  "tabIcon": "ui-module__Hi2WXW__tabIcon",
  "tabbar": "ui-module__Hi2WXW__tabbar",
});
